import { View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';

const theme = createDSTheme();

export const ItemSeparator = () => <View style={{ height: theme.spacing['spacing.general.x1'] }} />;
